import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";
import { useGetTutorQuery } from "../Auth/useGetTutorQuery";

export const useUpdateTutorProfile = () => {
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  const { data } = useGetTutorQuery();

  return useMutation(
    ({
      availabilityType,
      hourlyRate,
      bio,
      country,
    }: {
      availabilityType?: string;
      hourlyRate?: number;
      bio?: string;
      country?: string;
    }) =>
      axiosInstance
        .patch(
          "tutors/other-profile",
          {
            availabilityType: availabilityType ?? data?.data?.availabilityType,
            country: country ?? data?.data?.country ?? "United States of America",
            hourlyRate: hourlyRate ?? data?.data?.hourlyRate,
            bio: bio ?? data?.data?.bio ?? "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res: any) => res.data),
    {
      onSuccess: async (data: any) => {
        message.success(data?.message);
        queryClient.invalidateQueries("gettutor");
      },
      onError: (error: any) => {
        message.error(error?.response?.data?.message);
      },
    },
  );
};
